import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function ProductShotIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<rect x="0.175768" y="0.175768" width="19.6485" height="19.6485" rx="3.82423" fill="#47B9AC" />
			<rect
				x="0.175768"
				y="0.175768"
				width="19.6485"
				height="19.6485"
				rx="3.82423"
				stroke="#E7E7E7"
				strokeWidth="0.351536"
				fill="#47B9AC"
			/>
			<path
				d="M8.75 6.25V8.125M11.25 6.25V8.125M14.375 11.4194V9.375C14.375 8.68464 13.8154 8.125 13.125 8.125H6.875C6.18464 8.125 5.625 8.68464 5.625 9.375V14.375C5.625 15.0654 6.18464 15.625 6.875 15.625H10.625M11.25 11.875C11.25 12.5654 10.6904 13.125 10 13.125C9.30964 13.125 8.75 12.5654 8.75 11.875C8.75 11.1846 9.30964 10.625 10 10.625C10.6904 10.625 11.25 11.1846 11.25 11.875ZM8.125 4.375H11.875V6.25H8.125V4.375Z"
				stroke="white"
				strokeWidth="0.78125"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="#47B9AC"
			/>
			<path
				d="M14.0125 13.0534C14.1344 12.9315 14.2791 12.8348 14.4383 12.7689C14.5976 12.7029 14.7683 12.6689 14.9406 12.6689C15.113 12.6689 15.2837 12.7029 15.4429 12.7689C15.6022 12.8348 15.7469 12.9315 15.8687 13.0534C15.9906 13.1753 16.0873 13.32 16.1533 13.4792C16.2192 13.6385 16.2532 13.8091 16.2532 13.9815C16.2532 14.1539 16.2192 14.3246 16.1533 14.4838C16.0873 14.6431 15.9906 14.7878 15.8687 14.9096L13.75 17.0471H11.875V15.1721L14.0125 13.0534Z"
				stroke="white"
				strokeWidth="0.78125"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="#47B9AC"
			/>
		</SvgIcon>
	);
}

export default ProductShotIcon;
